module.exports = __webpack_public_path__ + "static/img/A152.b9edd731.jpg";